//package import 
import React, { useState } from "react";

//component import
import { Button } from "@mui/material";
import uploadIcon  from "../../assests/images/uploadIcon.webp"


const FileUpload = (props) => {
  const { onClick, isAdmin,setFileState ,onClickDisplay ,from,id,name} = props;
  const [fileheight,setFileHeight]=useState()
  const [fileWidth,setFileWidth]=useState()
  
  const handleFileChange = (event) => {
    // console.log("evene",event.target.files[0])
    const selectedFile = event.target.files[0];

    
    let file = event.target.files[0]
    let size = file.size
   

   
    const reader = new FileReader();
  
    reader.onload = (e) => {
      const img = new Image();
      img.src = e.target.result;
      img.onload = () => {
        const width = img.width;
        const height = img.height;

        setFileHeight(height)
        setFileWidth(width)

        let fileinfo = {
          height:height,
          width:width,
          fileSize:size
        }
  
  
        onClick(selectedFile,fileinfo)
      };

      img.onerror = (error) => {
        console.error('Error loading image:', error);
      };

    };

   

    
    reader.readAsDataURL(event.target.files[0]);
   
    
    // Update the file state using the provided setter function
  };

  return (
    <>
      <input
        className="fileUploaddisplay"
        id={id}
        type="file"
        onChange={handleFileChange}
        onClick={(e)=> { 
          e.target.value = null
     }}
        style={{ display: 'none' }}
        name={name}
        accept="image/*"
      />
      <Button
      htmlFor={id}
      component="label"
      class="btn-sm"
      >
      <img src={uploadIcon} htmlFor={name} class="cursorPointer"   alt="upload-icon"/> 
       
      </Button>
         
    </>
  );
};

export default FileUpload;
